export function imageApi(imageData, params) {
  let { src, width, height, ...rest } = imageData;
  if (window.location.protocol === "https:") {
    src = src.replace("http:", "https:");
  }
  src = src + "?quality=80&";
  let max = window.innerWidth < 548 ? Math.round(params.max * 0.5) : params.max;
  if (max && width > height) {
    src += "width=" + max;
  } else if (max) {
    src += "height=" + max;
  }
  if (params.fixHeight) {
    src += "height=" + params.fixHeight;
  }
  if (params.fixWidth) {
    src += "width=" + params.fixWidth;
  }
  return { src, width, height, ...rest };
}

export function slugify(str) {
  return str.toLowerCase().replace(/\s+/g, "-");
}

export function dividerify(str) {
  return str.replace("(divider)", '<hr class="divider" />');
}

const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

export function monthName(index) {
  return MONTHS[index];
}

export function prettyDate(str) {
  const today = new Date();
  const date = new Date(str);
  let out = monthName(date.getMonth()) + " " + date.getDate();
  if (today.getFullYear() !== date.getFullYear()) {
    out += ", " + date.getFullYear();
  }
  return out;
}

export function formatLink(text) {
  if (text.indexOf(".pdf") > -1)
    return text.replace(/>.*</gi, ' target="_blank">(pdf)<');
  return text.replace(/>.*</gi, ' target="_blank">(link)<');
}

export const BREAKPOINTS = {
  sm: 768
};

export function getBreakPoint(breakpoints) {
  let keys = Object.keys(breakpoints);
  let w = window.innerWidth;
  for (let i = 0; i < keys.length; i++) {
    if (w < breakpoints[keys[i]]) return keys[i];
  }
  return "default";
}

export function getPlaceholderColor(color) {
  let parts = color.replace(/[^0-9,]/g, "").split(",");
  return parts.reduce((acc, v, i) => {
    return (
      acc +
      Math.round(v * 0.8) + // Value
      (i === parts.length - 1 ? ")" : ",")
    ); // , or closing )
  }, "rgb(");
}

export function getContainDimensions(aspect, win_w, win_h) {
  let width,
    height,
    left,
    top,
    win_a = win_w / win_h;
  if (win_a < aspect) {
    width = win_w;
    height = win_w / aspect;
    top = (win_h - height) * 0.5;
    left = 0;
  } else {
    width = win_h * aspect;
    height = win_h;
    left = (win_w - width) * 0.5;
    top = 0;
  }
  return { width, height, left, top };
}

export function randomInt(end, start = 0) {
  return start + Math.floor(Math.random() * (end - start));
}

export function withOrdinalSuffix(i) {
  let j = i % 10;
  let k = i % 100;
  if (j == 1 && k != 11) {
    return i + "st";
  }
  if (j == 2 && k != 12) {
    return i + "nd";
  }
  if (j == 3 && k != 13) {
    return i + "rd";
  }
  return i + "th";
}

import { TweenLite } from "gsap";
const SCROLL_POS = {
  x: 0,
  y: 0
};
export function scrollWindowTo(el, offset = 0, duration = 0.75) {
  let to = 0;
  to = el.getBoundingClientRect().top + window.pageYOffset + offset;
  // Clean Up Previous Scrolls
  TweenLite.killTweensOf(SCROLL_POS);
  if (Math.abs(to - window.pageYOffset) > 1000) {
    window.scrollTo(0, to + Math.sign(window.pageYOffset - to) * 1000);
  }
  SCROLL_POS.y = window.pageYOffset;
  // Animate Scroll
  TweenLite.to(SCROLL_POS, duration, {
    y: to,
    ease: Cubic.easeOut,
    onUpdate() {
      window.scrollTo(SCROLL_POS.x, SCROLL_POS.y);
    }
  });
}

export function getEmbedAspect(str) {
  let width = str.match(/width=["']([0-9]+)["']/im);
  if (width) width = parseFloat(width[1]);
  let height = str.match(/height=["']([0-9]+)["']/im);
  if (height) height = parseFloat(height[1]);
  if (width && height) {
    return width / height;
  }
  return 0.5;
}

export function appendIframeParams(str) {
  let src = str.match(/src=["']([^"']+)["']/im);
  if (src) {
    src = src[1];
    let params = "autoplay=1&background=1";
    if (src.indexOf("?") > 0) {
      src += "&" + params;
    } else {
      src += "?" + params;
    }
  }
  return str.replace(/src=["'][^"']+["']/im, 'src="' + src + '"');
}
